function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47042",
    d: "m9.726 5.42-7.657 7.657a1.771 1.771 0 0 0-.506 1.049l-.305 2.679A1.347 1.347 0 0 0 2.6 18.293h.156l2.679-.305a1.8 1.8 0 0 0 1.049-.5l7.657-7.665z",
    transform: "translate(-1.25 -2.315)",
    style: {
      fill: "#2973f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47043",
    d: "m19.921 3.705-1.942-1.942a1.749 1.749 0 0 0-2.478 0l-1.8 1.8 4.42 4.42 1.8-1.8a1.749 1.749 0 0 0 0-2.478z",
    transform: "translate(-4.436 -1.248)",
    style: {
      fill: "#2973f0"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.719722ebd67019ce4ac3e1a9ab912eeb.svg";
export { ForwardRef as ReactComponent };